import { render } from "./page-service-detail.vue?vue&type=template&id=6da43dad&scoped=true"
import script from "./page-service-detail.vue?vue&type=script&lang=js"
export * from "./page-service-detail.vue?vue&type=script&lang=js"

import "./page-service-detail.vue?vue&type=style&index=0&id=6da43dad&scoped=true&lang=css"

import exportComponent from "D:\\project\\BahteraAdhiguna\\deployment\\ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6da43dad"]])

export default __exports__